import bus from '~/bus'
import {getEventFile} from '~/helpers/eventHelper'

export default {
  name: 'restored',
  do: function (payload) {
    console.log('DEBUG restored: ', this, payload)
    bus.$emit('refreshTrash')
    if (this.fileChildren && this.fileChildren.includes(payload.parent_id)) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    if (this.file === 'trash') {
      bus.$emit('deleteFile', payload.deprecated_file_id)
    }
    if ((this.file === 'recent' && payload.recent) ||
      (this.file === 'myspace' && payload.parent_id === '') ||
      this.file === payload.parent_id) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('insertFile', response)
        this.fileChildren.push(payload.file_id)
      })
    }
    if (this.file === 'shared' ||
      this.file === payload.owner) {
      bus.$emit('doBackgroundReload', 'restored')
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/restored.js